export enum PaymentInstrument {
	PaymentCard = "PAYMENT_CARD",
	BankAccount = "BANK_ACCOUNT",
	GPay = "GPAY",
	ApplePay = "APPLE_PAY",
	// PayPal = "PAYPAL",
}
